<template>
  <div class="d-flex flex-column fill-height" ref="top-level-container">
    <div id="scroll-container" class="flex-grow-1" @scroll="scroll">
      <div v-for="post in posts" class="card-container pa-4">
        <video-card :post="post" />
      </div>
    </div>
  </div>
</template>

<style scoped>
#scroll-container {
  height: 0;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
}

.card-container {
  scroll-snap-align: start;
  scroll-snap-stop: normal;
}
</style>

<script>
import VideoCard from '@/components/VideoCard.vue';

export default {
  name: 'discover',
  components: {
    VideoCard
  },
  data() {
    return {
      posts: [
        { creator: 'Birch Periera', at: 'Friday, 5:00 PM' },
        { creator: 'Alex Exarhos', at: 'Friday, 3:44 PM' }
      ]
    };
  },
  methods: {
    scroll(e) {
      const isAtBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= 1;
      if (isAtBottom) {
        this.posts.push({ creator: 'Alex Exarhos', at: 'Friday, 3:44 PM' });
        this.$nextTick(this.resize);
      }
    },
    resize() {
      const h = this.$refs['top-level-container'].offsetHeight;
      document.getElementById('scroll-container').style['scroll-snap-points-y'] = 'repeat(' + h + 'px)';
      const setHeight = x => x.style['height'] = h + 'px';
      document.getElementsByClassName('card-container').forEach(setHeight);
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  mounted() {
    this.$nextTick(this.resize);
    window.addEventListener('resize', this.resize);
  }
}
</script>
